module.exports = __webpack_public_path__ + "static/media/icon_location_office_1.f7d08ea5.svg";